import { HttpFailedToFetchException } from "../model/httpException";
import { UserSubscription } from "../model/userSubscription";
import { getAuthHeaders } from "../utils/authHeaders";
import { logException } from "../utils/logUtils";

export class UserApi {
  private static readonly BASE_URL = import.meta.env.VITE_API_URL;
  private static readonly BASE_ENDPOINT = "user";

  static async initUser() {
    const headers = await getAuthHeaders({});

    const response = await fetch(
      `${this.BASE_URL}/${this.BASE_ENDPOINT}/init`,
      {
        method: "GET",
        headers,
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      logException("User API error (/user/init): ", {
        status: response.status,
        statusText: response.statusText,
        body: errorText,
      });
      throw new HttpFailedToFetchException();
    }
  }

  static async loadUserSubscription(): Promise<UserSubscription> {
    const headers = await getAuthHeaders({});

    const response = await fetch(
      `${this.BASE_URL}/${this.BASE_ENDPOINT}/plan`,
      {
        method: "GET",
        headers,
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      logException("User API error (/user/plan): ", {
        status: response.status,
        statusText: response.statusText,
        body: errorText,
      });
      throw new HttpFailedToFetchException();
    }

    const responseJson = await response.json();
    return responseJson;
  }

  static async hasAccessToProject(projectId: string): Promise<boolean> {
    const headers = await getAuthHeaders({});

    const response = await fetch(
      `${this.BASE_URL}/${this.BASE_ENDPOINT}/authorize?projectId=${projectId}`,
      {
        method: "GET",
        headers,
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      logException(
        `User API error (/user/authorize?projectId=${projectId}): `,
        {
          status: response.status,
          statusText: response.statusText,
          body: errorText,
        }
      );
      if (response.status === 401) {
        return false;
      }
      throw new HttpFailedToFetchException();
    }

    return true;
  }
}
